import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { GenericResponse } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoicesService {

  private invoiceUrl : string =  environment.url;
  //private invoiceUrl: string = AppConfig.settings.apiServer.url;
  private WorkflowStates: any[] = [];
  private Doctype: any[] = [];
  private DoctypeP: any[] = [];

  private labels: any[] = [];

  public setPageSize: number = 100;           // Schedulatore - settaggio paginazione
  constructor(private http: HttpClient, private router: Router) { }



  initService() {
    this.WorkflowStates = [];
    this.Doctype = [];
    this.DoctypeP = [];
    this.labels = [];
  }


  /**
   * Funzione per visualizzare la struttura del tipo documentale "Fattura Elettronica Attiva"
   * @param user_id 
   * @returns
   

   async getDoctype(user_id:any) : Promise<GenericResponse>{
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/').toPromise().then((data : any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  */
  async getDoctype(user_id: any): Promise<GenericResponse> {
    if (this.Doctype[user_id] == undefined)
      this.Doctype[user_id] = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/')
        .toPromise()
        .then((data: any) => {
          return data;
        }).catch((error) => {
          if (error.status == 403) {
            this.router.navigate(['../Login']);
            return ;
          } else {
            return {success: false, msg: error.message};
          }
          
        });
    return this.Doctype[user_id];
  }



  /**
   * Funzione per visualizzare la struttura del workflow "Fatturazione Elettronica Attiva"
   * @param user_id 
   * @returns 
   *
  async getWorkflowStates(user_id:any) : Promise<GenericResponse>{
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/').toPromise().then((data : any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }*/


  async getWorkflowStates(user_id: any): Promise<GenericResponse> {
    if (this.WorkflowStates[user_id] == undefined)
      this.WorkflowStates[user_id] = this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/').toPromise().then((data: any) => {
        return data;
      }).catch((error) => {
        if (error.status == 403) {
          this.router.navigate(['../Login']);
          return ;
        } else {
          return {success: false, msg: error.message};
        }
      });

    return this.WorkflowStates[user_id];
  }


  async getDocument(docId: string, userId: any): Promise<GenericResponse> {
    return await this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + docId + '/view_alt')
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }

  async anteprimaPassiva(docId: string, userId: any): Promise<GenericResponse> {
    return await this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/pinvoices/' + docId + '/view_alt')
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }


  /*async findInvoice(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/invoices', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      if (error.status == 403) {
        this.router.navigate(['../Login']);
        return ;
      } else {
        return {success: false, msg: error.message};
      }
    });
    return response;
  }*/

  async findAllInvoices(user_id: number | string, type: string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/' + type + '/allinvoices', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      if (error.status == 403) {
        this.router.navigate(['../Login']);
        return ;
      } else {
        return {success: false, msg: error.message};
      }
    });
    return response;
  }

  async deleteTask(user_id: number | string, id_task: number): Promise<GenericResponse> {
    let body = { id_task: id_task };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + user_id + '/delete_task', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }



  // /**
  //  * 
  //  * @param user_id 
  //  * @returns 
  //  */
  // async managedUser(user_id:any) : Promise<any>{
  //   let response = await this.http.get<any>(this.invoiceUrl + '/api/v1/users/' + user_id + '/managed_users/' + user_id).toPromise().then((data : any) => {
  //     return data;
  //   }).catch((error) => {
  //     return error;
  //   });
  //   return response;
  // }


  /**
   * Funzione per visualizzare la struttura del tipo documentale "Fattura Elettronica Passiva"
   * @param user_id
   * @returns 
   
  async getPassiveInvoiceDocType(user_id : number | string) : Promise<GenericResponse>{
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/p/').toPromise().then((data : any) => {
      return data;
    }).catch((error)=> {
      return error;
    });
    return response;
  }
  */

  async getPassiveInvoiceDocType(user_id: number | string): Promise<GenericResponse> {
    if (this.DoctypeP[user_id as any] == undefined)
      this.DoctypeP[user_id as any] = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/p/')
        .toPromise()
        .then((data: any) => { return data; }).catch((error) => { return error; });
    return this.DoctypeP[user_id as any];
  }


  /**
   * Funzione per visualizzare la struttura del workflow "Fatturazione Elettronica Passiva"
   * @param user_id 
   * @returns 
   */
  async getPassiveInvoiceWorkflowStates(user_id: number | string): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/p/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }


  /* DOCUMENT TYPE E WORKFLOW ORDINI INVIATI */

  async findOrdini(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/orderssent', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getOrdiniInviatiDocType(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/orderssent/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getOrdiniInviatiWorkflowStates(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/orderssent/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  /* DOCUMENT TYPE E WORKFLOW ORDINI RICEVUTI */
  async findOrdiniRicevuti(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/orders', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getOrdiniRicevutiDocType(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/orders/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getOrdiniRicevutiWorkflowStates(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/orders/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async anteprimaOrdini(invoiceId: string, userId: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + invoiceId + '/view_alt_order_ubl', {}).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  /* DOCUMENT TYPE E WORKFLOW PEPPOL UBL INVIATI */
  async findPeppolInviati(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/invoices/ubl', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getPeppolInviatiDocType(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/ubl/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getPeppolInviatiWorkflowStates(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/ubl/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async anteprimaUbl(invoiceId: string, userId: any, doctype: string): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + invoiceId + '/view_alt_' + doctype, {}).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  /* DOCUMENT TYPE E WORKFLOW PEPPOL UBL RICEVUTI */
  async findPeppolRicevuti(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/invoices/p/ubl', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getPeppolRicevutiDocType(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/p/ubl/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getPeppolRicevutiWorkflowStates(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/p/ubl/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }

  async getDDTInviatiDocType(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/ddt/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }
  async getDDTInviatiWorkflowStates(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/ddt/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }
  async getDDTRicevutiDocType(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/doctype/p/ddt/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }
  async getDDTRicevutiWorkflowStates(user_id: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/workflow_states/p/ddt/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }
  /**
   * Ricerca di fatture passive
   * @param user_id 
   * @param params 
   * @returns 
   */
  async findPassiveInvoice(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/invoices/p', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      if (error.status == 403) {
        this.router.navigate(['../Login']);
        return ;
      } else {
        return {success: false, msg: error.message};
      }
    });
    return response;
  }

  /* DOCUMENT TYPE E WORKFLOW PEPPOL DDT UBL INVIATI */
  async findDDTInviati(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/ddt/ubl', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }
  /* DOCUMENT TYPE E WORKFLOW PEPPOL DDT UBL RICEVUTI */
  async findDDTRicevuti(user_id: number | string, params: HttpParams): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/ddt/p/ubl', { params: params }).toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }


  /**
   * Scarica la struttura di una fattura elettronica vuota
   * @param user_id 
   * @returns 
   */
  async getUserInvoiceModel(user_id: number | string): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/models/einvoice/').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;
  }




  //api/v1/users/:user_id/sezionali

  /**
   * Funzione che mostra i sezionali impostati per l'utente specificato
   * @param user_id 
   * @returns 
   */
  async getUserSezionali(user_id: number | string): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + user_id + '/sezionali').toPromise().then((data: any) => {
      return data;
    }).catch((error) => {
      return error;
    });
    return response;

  }

  async getNotifications(list: string[], userId: any): Promise<GenericResponse> {
    let body = { relateds: list };
    let response = await this.http.post<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/view', body)
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        return error;
      });
    return response;
  }

  async getNotificationFile(invoiceId: string, notificationId: string, userId: any): Promise<GenericResponse> {
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' +
      invoiceId + '/view/relateds/' + notificationId, {})
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        return error;
      });
    return response;
  }

  async getPreviewMinist(invoiceId: string, userId: any,): Promise<GenericResponse> {
    let params = new HttpParams();
    params = params.append('complete', true);
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' +
      invoiceId + '/view', { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        return error;
      });
    return response;
  }

  async anteprimaPassivaMinist(invoiceId: string, userId: any,): Promise<GenericResponse> {
    let params = new HttpParams();
    params = params.append('complete', true);
    let response = await this.http.get<GenericResponse>(this.invoiceUrl + '/api/v1/users/' + userId + '/pinvoices/' +
      invoiceId + '/view', { params: params })
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        return error;
      });
    return response;
  }

  async uploadFile(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/upload', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadOrdine(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/orders/upload', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadUbl(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/upload_ubl', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }


  //ITEM può essere 'conserva' o 'notifica'
  async uploadInConservazione(userId: any, formData: FormData, option: string): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + option, formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadInPassiveConservazione(userId: any, formData: FormData, option: string): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/pinvoices/' + option, formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadOrdiniConservazione(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/orders/conserva', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadPOrdiniConservazione(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/porders/conserva', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadUblConservazione(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices-ubl/conserva', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadUblRicevuteConservazione(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/pinvoices-ubl/conserva', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async uploadDDTConservazione(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/ddt-ubl/conserva', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }
  async uploadDDT(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/ddt/upload_ubl', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }
  async uploadDDTRicevutiConservazione(userId: any, formData: FormData): Promise<GenericResponse> {
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/pddt-ubl/conserva', formData)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }
  async sendFileViaEmail(userId: any, docId: string, email: string): Promise<GenericResponse> {
    let body = { document_id: docId, email: email };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/send_attachment', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async downloadZip(userId: any, docsIdArray: string[]): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/downloadzip', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async downloadZipPassive(userId: any, docsIdArray: string[]): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray };
    return this.http.post(this.invoiceUrl + '/api/v1/fatture/' + userId + '/pinvoices/downloadzip', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async downloadPDF(userId: any, docsIdArray: string[], option: string, zip: boolean = true): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray, zipfile: zip };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/downloadpdf' + option + 'zip', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async downloadPDFPassive(userId: any, docsIdArray: string[], option: string, zip: boolean = true): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray, zipfile: zip };
    return this.http.post(this.invoiceUrl + '/api/v1/fatture/' + userId + '/pinvoices/downloadpdf' + option + 'zip', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async setDownload(userId: any, docsIdArray: string[], downloadCode: number): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray, download: downloadCode };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/setdownload', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async setPassivaDownload(userId: any, docsIdArray: string[], downloadCode: number): Promise<GenericResponse> {
    let body = { document_ids: docsIdArray, download: downloadCode };
    return this.http.post(this.invoiceUrl + '/api/v1/fatture/' + userId + '/pinvoices/setdownload', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async aggiornaMetadati(userId: any, docId: string | string[], doctype: string, metadato: string, value: string): Promise<GenericResponse> {
    let body = { document_id: docId, doctype: doctype, metatag: metadato, value: value };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/update_metatag', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }


  // path : '/download' per file originale
  //        '/download_no_signature' per xml
  //        '/attachment'  per allegati fattura
  async downloadInvoiceFiles(userId: any, docId: string, path: string): Promise<GenericResponse> {
    return this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/invoices/' + docId + path)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async downloadPassiveInvoiceFiles(userId: any, docId: string, path: string): Promise<GenericResponse> {
    return this.http.get(this.invoiceUrl + '/api/v1/fatture/' + userId + '/pinvoices/' + docId + path)
      .toPromise()
      .then((data: any) => {
        return data;
      });

  }

  async getLabels(userId: any): Promise<GenericResponse> {
    if (this.labels[userId] != undefined)
      return this.labels[userId];
    else
      this.labels[userId] = this.getLabelsData(userId);
    return this.labels[userId];
    /*return this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/label')
                    .toPromise()
                    .then((data : any) => {
                      return data;
                    });*/
  }

  private async getLabelsData(userId: any): Promise<GenericResponse> {
    return this.http.get(this.invoiceUrl + '/api/v1/users/' + userId + '/label')
      .toPromise()
      .then((data: any) => {
        return data;
      }).catch((error) => {
        if (error.status == 403) {
          this.router.navigate(['../Login']);
          return ;
        } else {
          return {success: false, msg: error.message};
        }
      });
  }




  async assignTag(userId: any, docIds: string[], tag: string): Promise<GenericResponse> {
    let body = { document_ids: docIds, tag: tag };
    return this.http.post(this.invoiceUrl + '/api/v1/users/' + userId + '/update_tag', body)
      .toPromise()
      .then((data: any) => {
        return data;
      });
  }

  async deleteDraft(userId: any, draftId: string): Promise<GenericResponse> {
    return this.http.delete(this.invoiceUrl + '/api/v1/users/' + userId + '/draft_invoices/' + draftId)
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }

  async accettaFattura(userId: string, invoiceId: string, motivo: any): Promise<GenericResponse> {
    return this.http.put(this.invoiceUrl + "/api/v1/users/" + userId + "/invoices/" + invoiceId + "/accept", motivo)
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }

  async rifiutaFattura(userId: string, invoiceId: string, motivo: any): Promise<GenericResponse> {
    return this.http.put(this.invoiceUrl + "/api/v1/users/" + userId + "/invoices/" + invoiceId + "/refuse", motivo)
      .toPromise()
      .then((data: any) => {
        return data;
      })
  }


}
